import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles(
  {
    wrapper: {
      padding: Spacings.s0,
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      gap: Spacings.s24,
      marginBottom: Spacings.s24,
      '@media screen and (max-width: 1200px)': {
        padding: [Spacings.s0, Spacings.s12],
      },
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(316px, 1fr))',
      gap: Spacings.s16,
      placeItems: 'center',
    },
    button: {
      alignSelf: 'center',
      fontWeight: FontWeights.bold,
    },
    title: {
      fontSize: FontSizes.s20,
      lineHeight: LineHeights.l28,
    },
  },
  {
    name: 'all-tools',
  },
);

export default useStyles;
